<section class="agpr-monitoring-expertBooleanSearch u-lgBottomMargin">
    <div class="agpr-monitoring-expertBooleanSearch-top">
        <div
            class="agpr-monitoring-expertBooleanSearch-top-left"
            [attr.aria-describedby]= "ariaDescribedBy"
        >
            <h4
                id="monitoring_expertBooleanSearch_label"
                class="agpr-monitoring-expertBooleanSearch-top-left-heading"
            >
                {{ 'Monitoring.ExpertBooleanSearch.input.textArea' | localize }}
            </h4>
            <agpr-monitoring-search-contexts
                [(ngModel)]="expertBooleanQuery.searchContexts"
                (ngModelChange)="processSearchContextsChange($event)"
            >
            </agpr-monitoring-search-contexts>
        </div>
        <div class="agpr-monitoring-expertBooleanSearch-top-right">
            <textarea
                pInputTextarea
                class="agpr-monitoring-expertBooleanSearch-queryText"
                id="monitoring_expertBooleanSearch_textarea"
                [placeholder]="'Monitoring.ExpertBooleanSearch.input.placeholder' | localize"
                [(ngModel)]="expertBooleanQuery.filter"
                (ngModelChange)="processQueryStringChange($event)"
                aria-labelledby="monitoring_expertBooleanSearch_label"
            ></textarea>
        </div>
    </div>
    <div class="agpr-expertHelp">
        <div class="agpr-expertHelp-heading">
            {{'Monitoring.ExpertBooleanSearch.help.heading' | localize}}
            <agpr-button
                id="monitoring_expertBooleanSearch_expandToggle"
                class="agpr-expertHelp-expand"
                [style]="buttonTypes.icon"
                [icon]="helpExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                (click)="helpExpanded = !helpExpanded;"
                [tooltip]="helpExpanded ? 'Core.collapse' : 'Core.expand'"
            ></agpr-button>
        </div>
        <div
            class="agpr-expertHelp-content"
            [@containerState]="helpExpanded ? 'visible' : 'hidden'"
        >
            <ul class="agpr-expertHelp-list">
                <li class="agpr-expertHelp-item">
                    {{ 'Monitoring.ExpertBooleanSearch.help.point1' | localize }}
                </li>
                <li class="agpr-expertHelp-item">
                    {{ 'Monitoring.ExpertBooleanSearch.help.point2' | localize }}
                </li>
                <li class="agpr-expertHelp-item">
                    {{ 'Monitoring.ExpertBooleanSearch.help.point3' | localize }}
                </li>
                <li class="agpr-expertHelp-item">
                    {{ 'Monitoring.ExpertBooleanSearch.help.point4' | localize }}
                </li>
                <li class="agpr-expertHelp-item">
                    {{ 'Monitoring.ExpertBooleanSearch.help.point5' | localize }}
                </li>
            </ul>
        </div>
    </div>
</section>
